import type { ComponentType } from 'react';
import type { CampaignTemplate } from '@/connection/campaigns/fetch-campaign-templates';
import { Capri } from './capri.tsx';
import { Astoria } from './astoria.tsx';
import { Sterling } from './sterling.tsx';
import { Montclair } from './montclair.tsx';
import { Amalfi } from './amalfi.tsx';
import { Florence } from './florence.tsx';
import { Chateau } from './chateau.tsx';
import { Laurent } from './laurent.tsx';
import { Palais } from './palais.tsx';
import { Aurelia } from './aurelia.tsx';
import { Viceroy } from './viceroy.tsx';
import { Carlton } from './carlton.tsx';
import { Siena } from './siena.tsx';
import { templateStaticDefaults } from './template-defaults';
import type { TemplateProps, CampaignTemplateDefault } from './campaign-template.types';

export type {
  TemplateProps,
  LocalCampaignTemplate,
  CampaignColorContrastPair,
  CampaignTemplateDefault,
  EmailColors,
} from './campaign-template.types';

export const campaignTemplates: CampaignTemplate[] = [
  { uuid: 'capri', title: 'Capri', category: 'Modern' },
  { uuid: 'astoria', title: 'Astoria', category: 'Classic' },
  { uuid: 'sterling', title: 'Sterling', category: 'Bold' },
  { uuid: 'montclair', title: 'Montclair', category: 'Classic' },
  { uuid: 'amalfi', title: 'Amalfi', category: 'Modern' },
  { uuid: 'florence', title: 'Florence', category: 'Bold' },
  { uuid: 'chateau', title: 'Chateau', category: 'Classic' },
  { uuid: 'laurent', title: 'Laurent', category: 'Classic' },
  { uuid: 'palais', title: 'Palais', category: 'Classic' },
  { uuid: 'aurelia', title: 'Aurelia', category: 'Bold' },
  { uuid: 'viceroy', title: 'Viceroy', category: 'Modern' },
  { uuid: 'carlton', title: 'Carlton', category: 'Classic' },
  { uuid: 'siena', title: 'Siena', category: 'Modern' },
];

export const campaignTemplatesMap: Map<string, ComponentType<TemplateProps>> = new Map([
  ['capri', Capri],
  ['astoria', Astoria],
  ['sterling', Sterling],
  ['montclair', Montclair],
  ['amalfi', Amalfi],
  ['florence', Florence],
  ['chateau', Chateau],
  ['laurent', Laurent],
  ['palais', Palais],
  ['aurelia', Aurelia],
  ['viceroy', Viceroy],
  ['carlton', Carlton],
  ['siena', Siena],
]);

export const campaignTemplatesDefaults: Map<string, CampaignTemplateDefault> = new Map([
  ...Array.from(campaignTemplatesMap.keys()).map((uuid): [string, CampaignTemplateDefault] => [
    uuid,
    {
      salutation: templateStaticDefaults[uuid]?.salutation ?? "You've been invited to",
      startIntro: 'The show starts on',
      cta: templateStaticDefaults[uuid]?.cta ?? 'REGISTER',
      headingFont: 'Arial',
      bodyFont: 'Arial',
      contrasts: [
        ['containerColor', 'buttonTextColor'],
        ['containerColor', 'bodyTextColor'],
      ],
    },
  ]),
]);
